import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { PageLayout } from "./components/PageLayout";
import LoginPage from './components/LoginPage';
import logo from './jkabrasillogo-horizontal.png';
import Navigation from './Nav';
import './i18n';

import Admin from './view/Admin';
import Teachers from './view/Teachers';

// ==================== AFILIADOS ====================
import AffiliatesPage from './pages/AffiliatesPage';
import ActiveAffiliatesPage from './pages/ActiveAffiliatesPage';
import ActiveAssociateAffiliatesPage from './pages/ActiveAssociateAffiliatesPage';
import BlackbeltsPage from './pages/BlackbeltsPage';
import BlackbeltsByNamePage from './pages/BlackbeltsByNamePage';
import BlackbeltsStatePage from './pages/BlackbeltsStatePage';
import AffiliatesByNamePage from './pages/AffiliatesByNamePage';
import AffiliatesByJkaIdPage from './pages/AffiliatesByJkaIdPage';
import AffiliatesStatePage from './pages/AffiliatesStatePage';

// ==================== DOJOS ====================
import GymsPage from './pages/GymsPage';
import GymsAllStatePage from './pages/GymsAllStatePage';
import GymsNotAffiliatePage from './pages/GymsNotAffiliatePage';
import GymsStatePage from './pages/GymsStatePage';

import Instructors from './view/Instructors';
import Examiners from './view/Examiners';
import Judges from './view/Judges';
import EventsPage from './pages/EventsPage';
import EventRegistrationsPage from './pages/EventRegistrationsPage';
import Shihankai from './view/Shihankai';
import { GMapDemo } from './view/GMapDemo';
import DashboardPage from './pages/DashboardPage';

// ==================== CORPO DIRETIVO ====================
import BoardTermsPage from './pages/BoardTermsPage';
import BoardCompositionPage from './pages/BoardCompositionPage';
import BoardPositionsPage from './pages/BoardPositionsPage';

import FeesPage from './pages/FeesPage';

export default function App() {
    const { isAuthenticated, isAdmin, auth, loading } = useAuth();

    if (loading) return null; // aguarda GET /auth/me antes de decidir o que renderizar

    if (!isAuthenticated) {
        return <LoginPage />;
    }

    return (
        <PageLayout>
            <div className="App">
                <img src={logo} className="App-logo" alt="logo" width="300" height="100" />
                <Navigation />
                <BrowserRouter>
                    <Routes>
                        {/* Admin: restrito a usuários com grupo ADMIN */}
                        <Route path='/admin' element={isAdmin ? <Admin /> : <Navigate to="/" replace />} />

                        <Route path='/teachers' element={<Teachers />} />

                        {/* AFILIADOS */}
                        <Route path='/affiliates' element={<AffiliatesPage />} />
                        <Route path='/affiliatesByName' element={<AffiliatesByNamePage />} />
                        <Route path='/affiliatesByJkaId' element={<AffiliatesByJkaIdPage />} />
                        <Route path='/activeAffiliates' element={<ActiveAffiliatesPage />} />
                        <Route path='/activeAssociateAffiliates' element={<ActiveAssociateAffiliatesPage />} />
                        <Route path='/affiliatesState' element={<AffiliatesStatePage />} />
                        <Route path='/blackbelts' element={<BlackbeltsPage />} />
                        <Route path='/blackbeltsByName' element={<BlackbeltsByNamePage />} />
                        <Route path='/blackbeltsState' element={<BlackbeltsStatePage />} />

                        {/* DOJOS */}
                        <Route path='/gyms' element={<GymsPage />} />
                        <Route path='/gymsallstate' element={<GymsAllStatePage />} />
                        <Route path='/gymsnotaffiliate' element={<GymsNotAffiliatePage />} />
                        <Route path='/gymsstate' element={<GymsStatePage />} />

                        {/* TODO: confirmar acesso — avaliar se /judges e /examiners exigem JUDGE_ADMIN */}
                        <Route path='/events' element={<EventsPage />} />
                        <Route path='/events/:id/registrations' element={<EventRegistrationsPage />} />
                        <Route path='/judges' element={<Judges />} />
                        <Route path='/shihankai' element={<Shihankai />} />
                        <Route path='/maps' element={<GMapDemo />} />
                        <Route path='/instructors' element={<Instructors />} />
                        <Route path='/examiners' element={<Examiners />} />
                        {/* CORPO DIRETIVO */}
                        <Route path='/board/terms' element={<BoardTermsPage />} />
                        <Route path='/board/terms/:id/composition' element={<BoardCompositionPage />} />
                        <Route path='/board/positions' element={<BoardPositionsPage />} />
                        <Route path='/fees' element={<FeesPage />} />

                        <Route path="/" element={<DashboardPage />} />
                    </Routes>
                </BrowserRouter>
            </div>
        </PageLayout>
    );
}
